import { EventBus } from "./EventBus";
import { DataV2API } from "@/store/api/Endpoints";

EventBus.$on("send-client-error-info-to-server", errorObj => DataV2API.post("/error", errorObj));
EventBus.$on("send-client-error-info-to-server", console.error);
